<template>
  <div>
    <div id="ciyun"></div>
  </div>
</template>
<script>
import echarts from "echarts"
export default {
  props: ["ciyun"],
  data() {
    return {
      option: {
        toolbox: {
          show: true,
          orient: "vertical", //'horizontal',  //横向显示  纵向(vertical)
          // left: 'right',
          // top: 'center',
          feature: {
            mark: { show: true },
            // dataView : {show: true, readOnly: false},
            restore: { show: true },
            saveAsImage: { show: true }
          }
        },
        series: [
          {
            type: "wordCloud",
            gridSize: 2, //调整词之间的距离
            sizeRange: [20, 35], //[20, 110],   //调整字的大小范围
            rotationRange: [-60, 60], //数据旋转范围(范围内随机)
            // rotationStep: 15,  //设置旋转步
            shape: "circle", //'rectangle', //'cloud',//'circle','rect'(矩形)  //'pentagon'(五角星),  //形状设置(默认圆形)
            width: 1200, //1500,//1500,
            height: 700, //1000,//700,
            drawOutOfBound: true, //允许在画布外绘制文字
            textStyle: {
              normal: {
                color: function() {
                  return (
                    "rgb(" +
                    [
                      Math.round(Math.random() * 255), //160
                      Math.round(Math.random() * 255),
                      Math.round(Math.random() * 255)
                    ].join(",") +
                    ")"
                  );
                }
              }
              // emphasis: {      //鼠标悬停时阴影效果的显示
              // shadowBlur: 10,
              // shadowColor: '#333'
              // }
            },
            data: ["ciyunArr"]
            //name和value建议用小写,否则可能会出现兼容性问题
            //value越大显示的字体就越大
          }
        ]
      }
    };
  },
  methods: {
    ciyunoptions() {
      let chart=echarts.init(document.querySelector("#ciyun"))
      chart.setOption(this.option);
      window.onresize = chart.resize;
    }
  },
  watch: {
    ciyun(newval){
      console.log(newval);
      if(newval){
        this.option.series[0].data=newval

        setTimeout(()=>{
          this.ciyunoptions()
        },1000)
      }
    }
  }
};
</script>
<style lang="scss" scoped>
#ciyun {
  width: 100%;
  height: 100%;
}
</style>